import { cofaceContractStates } from 'shared/constants/creditReview/cofaceContractStates';
import {
  GET_CREDIT_REVIEW_CONTRACT_DATA_SUCCESS,
  GET_CREDIT_REVIEW_CONTRACT_DATA_ERROR,
} from './creditReviewActions';

const initialState = {
  isPending: true,
  cofaceRequestPermission: false,
  cofaceRequestsAllowed: 0,
  cofaceContractState: cofaceContractStates.inactive,
};

export function creditReview(state = initialState, action) {
  const { payload, type } = action;
  const { cofaceRequestPermission, cofaceRequestsAllowed, cofaceTotalAmount, cofaceContractState } =
    payload || {};

  switch (type) {
    case GET_CREDIT_REVIEW_CONTRACT_DATA_SUCCESS:
      return {
        ...state,
        isPending: false,
        cofaceRequestPermission,
        cofaceRequestsAllowed,
        cofaceTotalAmount,
        cofaceContractState,
      };
    case GET_CREDIT_REVIEW_CONTRACT_DATA_ERROR:
      return { ...state, isPending: false };
    default:
      return state;
  }
}
